(function () {
    'use strict';

    var module = angular.module('uwAgenda.email');
    module.factory('EmailService', ['$http', '$uibModal', '$uibModalStack', 'Email', 'SharedAgendaService', EmailServiceFn]);

    /* service for requesting email */
    function EmailServiceFn($http, $uibModal, $uibModalStack, Email, SharedAgendaService) {

        var baseUrl = '/api/messages/';
        var service = {
            query: query,
            send: send,
            deactivate: deactivate,
            preview: preview,
            show: show,
            write: write,
            writeTo: writeTo
        };

        return service;

        /* list all emails */
        function query(ownerId, showAll, messageType) {
            return $http({
                url: baseUrl + ownerId + '/' + (showAll ? showAll : false),
                method: 'GET',
                params: {
                    messageType: messageType ? messageType : null
                }
            }).then(function (response) {
                return response.data;
            });
        }

        /* posts email */
        function send(email, copyToMe, userId) {
            return $http.post(baseUrl + 'mail/' + copyToMe + '/' + userId, email).then(function (response) { return response.data; });
        }

        /* deactivate email */
        function deactivate(id) {
            return $http.delete(baseUrl + id + '/users/' + SharedAgendaService.currentUser().id).then(function (response) { return response.data; });
        }

        function preview(id) {
            return $http.get(baseUrl + 'users/' + SharedAgendaService.currentUser().id + '/preview/' + id).then(function (response) { return response.data; });
        }

        // Show Message
        function show(id) {
            // show modal
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                animation: true,
                templateUrl: '/app/email/overview/templates/email-detail-show.template.html',
                controller: 'DetailShowEmailController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    email: preview(id)
                }
            });

            // when modal is closed
            modalInstance.result.then(function () {
            }, function () {
                // dismissed
            });
        } // show

        // Write New Email
        function write(email) {
            // open modal
            return $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                animation: true,
                templateUrl: '/app/email/overview/templates/email-detail.template.html',
                controller: 'DetailEmailController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    email: function () { return email; },
                    signature: ['UserService', function (UserService) {
                        // set email-signature
                        return UserService.signature(SharedAgendaService.currentUser().id, SharedAgendaService.data.currentAgenda.id).then(function (result) {
                            return result;
                        });
                    }]
                }
            });
        } // write

        // Write New Email To Defined Address
        function writeTo(emailAddress) {

            // close other modals
            $uibModalStack.dismissAll();

            // email
            var email = new Email();
            email.addMailContactInfo(emailAddress);

            // open modal
            return write(email);
        } // writeTo
    }
})();